import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { getOrganizationStatements, GetOrganizationStatementsParams } from '@/api/statements';
import { IStatementShortInfo } from '@/utils/types';
import { ErrorAlertModule } from '@/store/modules/errors';
import { dateWithoutTime } from '@/filters';

export interface IOrganizationStatementsState {
  items: IStatementShortInfo[];
  total: number;
}

@Module({
  dynamic: true,
  store,
  name: 'organizationStatements',
  namespaced: true,
})
class OrganizationStatements
  extends VuexModule
  implements IOrganizationStatementsState {
  items: IStatementShortInfo[] = [];
  loading = false;
  total = 0;

  @Mutation
  getOrganizationStatementsPending() {
    ErrorAlertModule.setErrorAlert('');
    this.items = [];
    this.total = 0;
    this.loading = true;
  }

  @Mutation
  getOrganizationStatementsFulfilled({
    items,
    total,
  }: {
    items: IStatementShortInfo[];
    total: number;
  }) {
    this.items = items.map((statement) => ({
      ...statement,
      createDate: dateWithoutTime(statement.createDate),
    }));
    this.total = total;
    this.loading = false;
  }

  @Mutation
  getOrganizationStatementsRejected(error: any) {
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.errorString
    ) {
      ErrorAlertModule.setErrorAlert(error.response.data.errorString);
    }
    this.loading = false;
  }

  @Action({ rawError: true })
  async getOrganizationStatements(params: GetOrganizationStatementsParams) {
    this.getOrganizationStatementsPending();

    try {
      const { items, count } = await getOrganizationStatements(params);
      this.getOrganizationStatementsFulfilled({ items, total: count });
    } catch (error) {
      this.getOrganizationStatementsRejected(error);
    }
  }
}

export const OrganizationStatementsModule = getModule(OrganizationStatements);
